var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFlow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    mask: "url(#b)",
    d: "M22.591 17.572h2.964v2.964h-2.964z"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#00EF8B",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M24.286 17.713h5.927v5.927h-5.927zM18.375 25.867a2.226 2.226 0 1 1-2.226-2.221h2.226v-5.933h-2.242a8.153 8.153 0 1 0 8.154 8.154v-2.221h-5.912v2.22zM26.507 14.747h6.673V8.82h-6.673a8.158 8.158 0 0 0-8.132 8.153v.74h5.912v-.74a2.231 2.231 0 0 1 2.22-2.226z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#16FF99",
    d: "M18.36 23.646h5.927v-5.933h-5.928z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFlow);
export default __webpack_public_path__ + "static/media/ic-flow.cb474f71e1ce6e03d08616b812b21a14.svg";
export { ForwardRef as ReactComponent };